import React from "react";
import InvestmentTable from "./list/SuitabilityList";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const Investment = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <InvestmentTable />
      </div>
    </div>
  );
};

export default Investment;
